import styled from 'styled-components';
import { MyPatternListProps } from '../../../interface/aiAnalyze/aiRecommend/type';
import { SidoList } from '../../search/FilterData';

interface Props {
  list: MyPatternListProps[];
  selectedItem: MyPatternListProps;
  setSelectedItem: (i: MyPatternListProps) => void;
  setIsRecommend: (i: boolean) => void;
}

const imgMap: Record<string, string> = {
  아파트: 'main_building_40',
  상가: 'main_building_40',
  '다세대/빌라': 'main_home_40',
  대지: 'main_mountain_40',
};

const categoryList = [
  '아파트',
  '다세대/빌라',
  '상가',
  '다세대/빌라',
  '아파트',
  '아파트',
];

const subCategoryList = [
  '단기 투자',
  '유찰 2회 이상',
  '장기 투자',
  '유찰 3회 이상',
  '실거주',
  '실거주',
];

const descList = [
  '높은 단가, 활발한 거래\n단기 수익 실현의 기회',
  '인천은 2번만 유찰돼도\n입찰가가 절반',
  '현금 흐름 만들고 싶다면?\n상가 낙찰로 월세 수익 만들기',
  '높은 입찰가가 부담스럽다면,\n지방 알짜 물건 탐색',
  '서울과 비슷한 환경이지만\n입찰가는 훨씬 저렴한 물건',
  '월세 수익도 실거주도 가능한\n합리적인 오피스텔 투자',
];
function RecommendAlgorithm({
  list,
  selectedItem,
  setSelectedItem,
  setIsRecommend,
}: Props) {
  return (
    <Container>
      {list.map((item, idx) => (
        <AlgorithmDiv
          onClick={() => {
            setSelectedItem(item);
            setIsRecommend(true);
          }}
          key={item.algorithm_idx}
          $active={selectedItem.algorithm_idx === item.algorithm_idx}
        >
          <Content>
            <Category>
              {SidoList.find((i) => i.code === item.pnu)?.region}・
              {categoryList[idx]}・{subCategoryList[idx]}
            </Category>
            <Description>{descList[idx]}</Description>
          </Content>
          <Img src={`/assets/images/main/${imgMap[categoryList[idx]]}.svg`} />
        </AlgorithmDiv>
      ))}
    </Container>
  );
}

export default RecommendAlgorithm;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  min-width: max-content;
  padding-right: 16px;
`;

const AlgorithmDiv = styled.div<{ $active: boolean }>`
  display: flex;
  flex: 0 0 282px;
  width: 282px;
  height: 130px;
  padding: 24px;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 16px;
  flex-shrink: 0;
  border-radius: 12px;
  background-color: #ffffff;
  box-shadow: 0px 4px 15px 0px rgba(141, 149, 163, 0.25);
  cursor: pointer;
  border: ${({ $active }) =>
    $active ? '2px solid #008aff' : '1px solid transparent'};
  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;
`;

const Img = styled.img`
  width: 40px;
  height: 40px;
`;

const Category = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #616161;
  white-space: nowrap;
  margin-bottom: 4px;
`;

const Description = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222222;
  word-break: keep-all;
`;
